import { Locale, type LocalizedString } from "../Locale.js";

export const podcastPathMap = {
	[Locale.cs]: "podcast" as const,
} satisfies LocalizedString;
